import { DashboardVehiclePurchaseInventoryTable } from "./Table";


const DashboardVehiclePurchaseInventory = () => {
    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <DashboardVehiclePurchaseInventoryTable />
        </div>
    );
};

export default DashboardVehiclePurchaseInventory;
